import React, { ComponentType } from 'react';

import { GetGroupColorsComponent, GroupColorMap } from 'api';
import { QueryManager } from 'components';

export interface IWithGroupColors {
  groupColors: GroupColorMap[];
}

type ChildComponent<T> = ComponentType<T & IWithGroupColors>;

const withGroupColors = <T extends {}>(Component: ChildComponent<T>) => (props: T) => (
  <GetGroupColorsComponent>
    {queryResult => (
      <QueryManager {...queryResult}>
        {() => <Component {...props} groupColors={queryResult.data.getGroupColors} />}
      </QueryManager>
    )}
  </GetGroupColorsComponent>
);

export default withGroupColors;
